const TinyChevronDown = () => (
  <>
    <path
      fill="currentColor"
      d="M8.755 10.627q0-.168.111-.289a.38.38 0 0 1 .293-.12h5.677q.182 0 .293.123a.42.42 0 0 1 .111.289q0 .04-.13.284l-2.678 2.676a.7.7 0 0 1-.199.143.55.55 0 0 1-.235.05.55.55 0 0 1-.236-.05.7.7 0 0 1-.199-.143l-2.677-2.677a.5.5 0 0 1-.093-.129.34.34 0 0 1-.038-.157"
    />
  </>
)
export default TinyChevronDown
